// Copyright (c) 2020-2023 dātma, inc™
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrCrudUrl } from '@/settings'
import { showToast } from '../../../utils/utils'

const reportUrl = `${ehrCrudUrl}/report-store/report/`

export const getReportFile = async (uuidVal, docType) => {
  if (uuidVal.length <= 10) { return [] }
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${reportUrl}${uuidVal}/doc`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      showToast('error', `Error with network request: ${response.status}`)
      return []
    }
    if (docType.indexOf('pdf') > 0) {
      return URL.createObjectURL(await response.blob())
    }
    const reportData = await response.text()

    return reportData
  } catch (e) {
    if (e.name === 'AbortError') {
      console.error('timeout error')
    } else {
      console.log(`error: status=${e.status}`)
    }
    showToast('error', `Error with network request: ${e.status}`)
  }
}
